function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1545 26.8724C17.6753 28.3464 16.0433 28.1166 14.4876 27.4217C12.8337 26.7127 11.3217 26.6679 9.57504 27.4217C7.39986 28.3856 6.2454 28.1054 4.93539 26.8724C-2.46076 19.0545 -1.36908 7.14544 7.03687 6.6971C9.07559 6.80918 10.503 7.85438 11.7038 7.94124C13.4887 7.56856 15.1972 6.50095 17.1076 6.64105C19.4029 6.8316 21.1196 7.76191 22.2658 9.43478C17.5443 12.349 18.6633 18.7379 23 20.5312C22.1321 22.871 21.0186 25.1828 19.1518 26.8921L19.1545 26.8724ZM11.5401 6.61303C11.319 3.13839 14.0619 0.280213 17.2168 0C17.6508 4.00705 13.6688 7.00533 11.5401 6.61303Z",
  fill: "#06302D"
});

function SvgIconApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/icon-apple.e330de24.svg";
export { ForwardRef as ReactComponent };